const getHeaderH = () => {
    const header = document.querySelector('header');
    return header.offsetHeight;
}

export default getHeaderH;